import { Box, DashboardModuleListItem, ListItem, Text } from '@domain-group/suit-theme'

import type { HandleCallbackActionParams } from '@functions/handleCallbackAction'

import type { CaptionsFormState } from '@hooks/useAdContent'

import type { CaptionModel } from '@models/types'

import type { CreateOrUpdateParams } from '@redux/modules/caption'

type HandleDeleteParams = {
  callbacks: {
    createOrUpdateCaptions: (payload: HandleCallbackActionParams) => void,
    createOrUpdateCaptionsFn: (captionsParams: CreateOrUpdateParams) => Promise<
      { success: true, data: CaptionModel } | { success: false, errors: string[] }
    >,
    setCaptionsFormState: React.Dispatch<React.SetStateAction<CaptionsFormState>>,
  },
  captionsFormState: CaptionsFormState,
  formStateKey: string,
  index: number,
  list: string[],
}

const handleDelete = (params: HandleDeleteParams) => {
  const {
    callbacks: {
      createOrUpdateCaptions,
      createOrUpdateCaptionsFn,
      setCaptionsFormState,
    },
    captionsFormState,
    formStateKey,
    index,
    list
  } = params

  // Mutate list by deleting the item
  list.splice(index, 1)

  const updatedCaptionsFormState = {
    ...captionsFormState,
    [formStateKey]: list,
  }

  setCaptionsFormState(updatedCaptionsFormState)

  createOrUpdateCaptions({
    callbacks: {
      action: createOrUpdateCaptionsFn,
    },
    entityParams: updatedCaptionsFormState,
    toastText: 'Ad Content Updated',
  })
}

interface AdContentListProps {
  callbacks: {
    createOrUpdateCaptions: (payload: HandleCallbackActionParams) => void,
    createOrUpdateCaptionsFn: (captionsParams: CreateOrUpdateParams) => Promise<
      { success: true, data: CaptionModel } | { success: false, errors: string[] }
    >,
    setCaptionsFormState: React.Dispatch<React.SetStateAction<CaptionsFormState>>,
  },
  captionsFormState: CaptionsFormState,
  formStateKey: string,
  label: string,
  list: string[],
}

const AdContentList = (props: AdContentListProps) => {
  const {
    callbacks: {
      createOrUpdateCaptions,
      createOrUpdateCaptionsFn,
      setCaptionsFormState,
    },
    captionsFormState,
    formStateKey,
    label,
    list,
  } = props
    
  const hasListItems = !!list.length

  return (
    <Box flexDirection="column">
      <Text
        color="bodyFontLightColor"
        display="flex"
        fontSize="xsmall"
        letterSpacing="1px"
      >
        {label}
      </Text>

      {list.map((listItem, index) => (
        <DashboardModuleListItem
          boxProps={{ paddingX: 0 }}
          isSidebar
          key={listItem}
          title={listItem}
        >
          <DashboardModuleListItem.Actions>
            <DashboardModuleListItem.Icon
              onClick={() => handleDelete({
                callbacks: {
                  createOrUpdateCaptions,
                  createOrUpdateCaptionsFn,
                  setCaptionsFormState,
                },
                captionsFormState,
                formStateKey,
                index,
                list,
              })}
              type="delete"
            />
          </DashboardModuleListItem.Actions>
        </DashboardModuleListItem>
      ))}

      {!hasListItems && (
        <ListItem boxProps={{ paddingY: 'large' }} disableHover>
          <Text fontSize="small">None</Text>
        </ListItem>
      )}
    </Box>
  )
}

export default AdContentList